import { TrackingApi } from "../../client-tracking";
import { APIOptionsWithoutAPIClass, useAPI } from "./useAPI";

export const useTrackingAPI = <T>({
  initialValue,
  handleRequest,
}: APIOptionsWithoutAPIClass<T, TrackingApi>) => {
  return useAPI<T, TrackingApi>({
    initialValue,
    APIClass: TrackingApi,
    handleRequest,
  });
};
